
<svg width="180" height="110" aria-label="A chart." style="overflow: hidden;">
    <rect x="0" y="0" width="180" height="110" stroke="none" stroke-width="0" fill="#ffffff"></rect>
    <g>
        <rect x="0" y="10" width="180" height="110" stroke="none" stroke-width="0" fill-opacity="0" fill="#ffffff"></rect>
        <g>
            <g>
                <rect x="1" y="6" width="151" height="21" stroke="none" stroke-width="0" fill="#4374e0"></rect>
                <rect x="1" y="60" width="139" height="21" stroke="none" stroke-width="0" fill="#4374e0"></rect>
                <rect x="1" y="28" width="63" height="21" stroke="none" stroke-width="0" fill="#53a8fb"></rect>
                <rect x="1" y="82" width="67" height="22" stroke="none" stroke-width="0" fill="#53a8fb"></rect>
            </g>
            <g>
                <rect x="0" y="0" width="1" height="110" stroke="none" stroke-width="0" fill="#333333"></rect>
            </g>
        </g>
    </g>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/bar-chart/bar-chart.html